import React, { FC } from 'react';
import { ComponentRendering, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { TRenderGenericPopup } from '../types/cardColumnLayout.types';

const RenderGenericPopup: FC<TRenderGenericPopup> = ({ rendering, isEE }) => {
  const genericPopupPlaceholder = rendering?.placeholders?.['jss-generic-popup'];
  if (!genericPopupPlaceholder?.length) return null;
  return (
    <div className={`card-column-layout__link card-column-layout__link--popup ${isEE ? 'generic-popupEE-width' : ''}`}>
      <Placeholder name={'jss-generic-popup'} rendering={rendering as ComponentRendering} />
    </div>
  );
};

export default RenderGenericPopup;
